// reducer.js
import {
  INITIAL_DATA,
  SELECT_ITEM,
  EDIT_ITEM,
  ADD_CHILD,
  DELETE_ITEM,
  MOVE_ITEM,
  PROMOTE_ITEM,
  TOGGLE_EXPAND
} from '../actions/types';
// import * as types from "../actions/types";

const initialState = {
  items: [],
  selectedId: null,
  editingId: null
};

function updateItem(items, id, updateFn) {
  return items.map(item => {
    if (item.did === id) {
      return updateFn(item);
    }
    if (item.children && item.children.length > 0) {
      return {
        ...item,
        children: updateItem(item.children, id, updateFn)
      };
    }
    return item;
  });
}

function findParent(items, id, parent = null) {
  for (const item of items) {
    if (item.did === id) return parent;
    if (item.children && item.children.length > 0) {
      const found = findParent(item.children, id, item);
      if (found) return found;
    }
  }
  return null;
}

function generateUniqueId(items) {
  let maxId = 0;
  const findMaxId = (items) => {
    items.forEach(item => {
      if (item.did > maxId) maxId = item.did;
      if (item.children && item.children.length > 0) {
        findMaxId(item.children);
      }
    });
  };

  findMaxId(items);
  return maxId + 1;
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case INITIAL_DATA:
      // Добавляем свойства isExpanded и show для управления отображением
      const processItems = (items) => {
        return items.map(item => ({
          ...item,
          isExpanded: item.isExpanded || false,
          show: item.show !== undefined ? item.show : true,
          children: item.children ? processItems(item.children) : []
        }));
      };

      return {
        ...state,
        items: processItems(action.payload)
      };

    case SELECT_ITEM:
      return {
        ...state,
        selectedId: action.payload,
        editingId: state.editingId === action.payload ? null : action.payload
      };

    case EDIT_ITEM:
      return {
        ...state,
        items: updateItem(state.items, action.payload.id, item => ({
          ...item,
          [action.payload.field]: action.payload.value
        }))
      };

    case ADD_CHILD:
      const newId = generateUniqueId(state.items);
      const newChild = {
        did: newId,
        name: "Новый элемент",
        role: 0,
        mid: 0,
        info: "",
        color: "",
        owner_did: action.payload,
        not_in: 0,
        application: 0,
        is_cycle: 0,
        sortorder: 0,
        is_position: 1,
        category: null,
        code: null,
        children: [],
        isExpanded: false,
        show: true
      };

      return {
        ...state,
        items: updateItem(state.items, action.payload, item => ({
          ...item,
          isExpanded: true, // Автоматически раскрываем родительский элемент
          children: [...(item.children || []), newChild]
        }))
      };

    case DELETE_ITEM:
      const removeItem = (items, id) => {
        return items.filter(item => {
          if (item.did === id) return false;
          if (item.children && item.children.length > 0) {
            item.children = removeItem(item.children, id);
          }
          return true;
        });
      };

      return {
        ...state,
        items: removeItem(state.items, action.payload),
        selectedId: state.selectedId === action.payload ? null : state.selectedId,
        editingId: state.editingId === action.payload ? null : state.editingId
      };

    case PROMOTE_ITEM:
      const parent = findParent(state.items, action.payload);
      if (!parent) return state;

      // Находим элемент для повышения
      let itemToPromote = null;
      const findItem = (items, id) => {
        for (const item of items) {
          if (item.did === id) {
            itemToPromote = item;
            break;
          }
          if (item.children && item.children.length > 0) {
            findItem(item.children, id);
          }
        }
      };
      findItem(state.items, action.payload);

      if (!itemToPromote) return state;

      // Удаляем элемент из детей родителя
      const itemsWithoutChild = updateItem(state.items, parent.did, item => ({
        ...item,
        children: item.children.filter(child => child.did !== action.payload)
      }));

      // Добавляем элемент на уровень родителя
      const parentParent = findParent(state.items, parent.did);
      if (parentParent) {
        return {
          ...state,
          items: updateItem(itemsWithoutChild, parentParent.did, item => ({
            ...item,
            children: [...item.children, { ...itemToPromote, owner_did: parentParent.did }]
          }))
        };
      } else {
        // Если родитель - корневой элемент
        return {
          ...state,
          items: [...itemsWithoutChild, { ...itemToPromote, owner_did: 0 }]
        };
      }

    case TOGGLE_EXPAND:
      return {
        ...state,
        items: updateItem(state.items, action.payload, item => ({
          ...item,
          isExpanded: !item.isExpanded
        }))
      };

    default:
      return state;
  }
}